import React, { FC } from 'react';

import { Text } from '@adsk/alloy-react-box';
import { IconButton, LinkButton } from '@adsk/alloy-react-button';
import FileHandler from '@adsk/alloy-react-file-handler';
import { XIcon } from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';

import AttachmentListItemIconPlaceholder from './AttachmentFileHandlerIconPlaceholder';
import { useTranslation } from '../../../i18n';
import AttachmentItemIcon from '../AttachmentItemIcon';

type AttachmentFileHandlerItemErrorStateProps = {
  error: string;
  name: string;
  allowRetry?: boolean;
  onRetry?: () => void;
  onDelete?: () => void;
};

const AttachmentFileHandlerItemErrorState: FC<
  AttachmentFileHandlerItemErrorStateProps
> = ({ error, name, onDelete, allowRetry, onRetry }) => {
  const { t } = useTranslation();

  return (
    <FileHandler
      alertMessage={error}
      name={name}
      renderFileName={() => (
        <Text style={{ color: theme.colors.charcoal500 }}>{name}</Text>
      )}
      variant={FileHandler.VARIANTS.ERROR}
      renderMainAction={() =>
        allowRetry ? (
          <LinkButton onClick={onRetry}>{t('RETRY')}</LinkButton>
        ) : null
      }
      renderSecondaryAction={
        error
          ? undefined
          : () => (
              <IconButton
                onClick={onDelete}
                data-testid="FileHandlerDeleteAttachment"
              >
                <XIcon />
              </IconButton>
            )
      }
      style={{ alignItems: 'center' }}
      renderIcon={() => (
        <AttachmentListItemIconPlaceholder>
          <AttachmentItemIcon name={name} color={theme.colors.charcoal500} />
        </AttachmentListItemIconPlaceholder>
      )}
    />
  );
};

export default AttachmentFileHandlerItemErrorState;
